import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const queryKeys = createQueryKeyStore({
    entities: {
        all: null,
        byId: (id: string) => [id],
        byClientId: (clientId: string) => [clientId],
    },
    reportEntities: {
        all: null,
        byId: (args: { reportId: string; leadEntityId: string }) => [args.reportId, args.leadEntityId],
    },
    jurisdictions: {
        all: null,
        byId: (id: string) => [id],
    },
    clients: {
        all: null,
        byId: (id: string) => [id],
        unlinked: null,
    },
    transactions: {
        all: null,
        byId: (id: string) => [id],
        byClientId: (clientId: string) => [clientId],
    },
    reports: {
        all: null,
        byId: (id: string) => [id],
        byClientId: (clientId: string) => [clientId],
    },
    reportTransactions: {
        all: null,
        detail: (reportId: string) => [reportId],
        byReportId: (reportId: string) => [reportId],
    },
    users: {
        all: null,
        byId: (id: string) => [id],
        current: null,
    },
});
